export const ProjectObjective = Object.freeze({
    PERSONAL: 'personal',        // Projet personnel
    COMPANY: 'company',          // Projet pour une entreprise
    SCHOOL: 'school',            // Projet pour une école
});
